import { Star } from "lucide-react";

const TestimonialSection = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See how Menumate is helping businesses like yours succeed
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-background rounded-2xl p-8 md:p-12 shadow-lg border">
            <div className="flex items-center mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            
            <blockquote className="text-xl md:text-2xl font-medium text-foreground mb-8 leading-relaxed">
              "Menumate has completely transformed how we manage our catering business. 
              The inventory tracking and order management features have saved us countless 
              hours every week. Our team can now focus on what we do best - creating 
              amazing food experiences for our clients."
            </blockquote>
            
            <div className="flex items-center">
              <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white font-semibold text-lg mr-4">
                SK
              </div>
              <div>
                <div className="font-semibold text-foreground">Shahrukh</div>
                <div className="text-muted-foreground">Beys Kitchen</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { TestimonialSection };